import React from 'react';
import { ClipboardIcon, FileTextIcon, SendIcon, CheckIcon } from 'lucide-react';
export function Process() {
  return <section id="process" className="py-16 md:py-24 bg-gray-50" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-183">
            Simple 4-Step Application Process
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-184">
            We've streamlined the ITIN application process to save you time and
            hassle.
          </p>
        </div>
        <div className="max-w-5xl mx-auto" data-id="element-185">
          <div className="relative" data-id="element-186">
            {/* Timeline line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-blue-200" data-id="element-187"></div>
            {/* Step 1 */}
            <div className="relative mb-12 md:mb-24" data-id="element-188">
              <div className="flex flex-col md:flex-row items-center" data-id="element-189">
                <div className="md:w-1/2 md:pr-16 mb-6 md:mb-0 md:text-right" data-id="element-190">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-191">
                    Complete Online Form
                  </h3>
                  <p className="text-gray-600" data-id="element-192">
                    Fill out our simple questionnaire with your personal
                    information and business details.
                  </p>
                </div>
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white border-4 border-white shadow md:absolute md:left-1/2 md:transform md:-translate-x-1/2" data-id="element-193">
                  <span className="text-lg font-bold" data-id="element-194">1</span>
                </div>
                <div className="md:w-1/2 md:pl-16 md:text-left hidden md:block" data-id="element-195">
                  <ClipboardIcon size={48} className="mx-auto md:mx-0 text-blue-600" data-id="element-196" />
                </div>
              </div>
            </div>
            {/* Step 2 */}
            <div className="relative mb-12 md:mb-24" data-id="element-197">
              <div className="flex flex-col md:flex-row-reverse items-center" data-id="element-198">
                <div className="md:w-1/2 md:pl-16 mb-6 md:mb-0 md:text-left" data-id="element-199">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-200">
                    Submit Documentation
                  </h3>
                  <p className="text-gray-600" data-id="element-201">
                    Upload digital copies of your identification documents. No
                    need to mail originals.
                  </p>
                </div>
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white border-4 border-white shadow md:absolute md:left-1/2 md:transform md:-translate-x-1/2" data-id="element-202">
                  <span className="text-lg font-bold" data-id="element-203">2</span>
                </div>
                <div className="md:w-1/2 md:pr-16 md:text-right hidden md:block" data-id="element-204">
                  <FileTextIcon size={48} className="mx-auto md:ml-auto text-blue-600" data-id="element-205" />
                </div>
              </div>
            </div>
            {/* Step 3 */}
            <div className="relative mb-12 md:mb-24" data-id="element-206">
              <div className="flex flex-col md:flex-row items-center" data-id="element-207">
                <div className="md:w-1/2 md:pr-16 mb-6 md:mb-0 md:text-right" data-id="element-208">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-209">
                    Expert Review & Filing
                  </h3>
                  <p className="text-gray-600" data-id="element-210">
                    Our IRS-certified agents review your application and file it
                    with the IRS on your behalf.
                  </p>
                </div>
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white border-4 border-white shadow md:absolute md:left-1/2 md:transform md:-translate-x-1/2" data-id="element-211">
                  <span className="text-lg font-bold" data-id="element-212">3</span>
                </div>
                <div className="md:w-1/2 md:pl-16 md:text-left hidden md:block" data-id="element-213">
                  <SendIcon size={48} className="mx-auto md:mx-0 text-blue-600" data-id="element-214" />
                </div>
              </div>
            </div>
            {/* Step 4 */}
            <div className="relative" data-id="element-215">
              <div className="flex flex-col md:flex-row-reverse items-center" data-id="element-216">
                <div className="md:w-1/2 md:pl-16 mb-6 md:mb-0 md:text-left" data-id="element-217">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-218">
                    Receive Your ITIN
                  </h3>
                  <p className="text-gray-600" data-id="element-219">
                    Get your ITIN number delivered to you and start using it for
                    your US business activities.
                  </p>
                </div>
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-600 text-white border-4 border-white shadow md:absolute md:left-1/2 md:transform md:-translate-x-1/2" data-id="element-220">
                  <span className="text-lg font-bold" data-id="element-221">4</span>
                </div>
                <div className="md:w-1/2 md:pr-16 md:text-right hidden md:block" data-id="element-222">
                  <CheckIcon size={48} className="mx-auto md:ml-auto text-blue-600" data-id="element-223" />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-16 text-center" data-id="element-224">
            <a href="#pricing" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-md font-medium inline-block transition-colors" data-id="element-225">
              Start Your Application Today
            </a>
          </div>
        </div>
      </div>
    </section>;
}